import { Route } from "@angular/router";
import { OfertaDetalhePage } from "./oferta-detalhe.page";

export const OfertaDetalheRouter: Route[] = [
  { path: 'oferta-detalhe', component: OfertaDetalhePage }
];
